import { render, staticRenderFns } from "./PromotionPlaceholder.vue?vue&type=template&id=81e747f2&scoped=true&"
import script from "./PromotionPlaceholder.vue?vue&type=script&lang=js&"
export * from "./PromotionPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e747f2",
  null
  
)

export default component.exports